import { useEffect, useRef, useState } from "react";
import DownSvg from "../../assets/svg/DownSvg.jsx";
import UpSvg from "../../assets/svg/UpSvg.jsx";
import './Dropdown.scss';
import gsap from "gsap";

function Dropdown({ options, filters, setFilters, label }) {
    const [isOpen, setIsOpen] = useState(false);
    const [isRender, setIsRender] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const dropdownRef = useRef(null);
    const optionsRef = useRef(null);

    const onSelectOption = (option) => {
        setSelectedOption(option)
        setIsOpen(false)
        if (option.type === "universes") {setFilters(prev => ({...prev, universe: option.value}))}
        else if (option.type === "rares") {setFilters(prev => ({...prev, rare: option.value}))}
    }

    const handleSelectBox = () => {
        setIsOpen(!isOpen)
        setIsRender(true)
    }

    useEffect(() => {
        if (!isOpen) return
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, [isOpen]);

    useEffect(() => {
        if (isOpen) {
            gsap.fromTo(optionsRef.current, {translateY: -25}, {
                opacity: 1,
                duration: 0.3,
                translateY: 0,
                ease: "power2.out",
            })
        } else {
            gsap.fromTo(optionsRef.current, {translateY: 0}, {
                opacity: 0,
                duration: 0.2,
                translateY: -25,
                ease: "power2.in",
                onComplete: () => setIsRender(false),
            })
        }
    }, [isOpen])

    useEffect(() => {
        if (filters.universe === null && filters.rare === null) {
            setSelectedOption(null)
        }
    }, [filters.universe, filters.rare])

    return (
        <div className='dropdown-wrapper' ref={dropdownRef}>
            <div className='select-box' onClick={handleSelectBox}>
                <span className='select-option'>{selectedOption && selectedOption.value ? selectedOption.label : label}</span>
                {isOpen ? <UpSvg className="up-svg" />: <DownSvg className="down-svg" />}
            </div>

            {isOpen || isRender ? <div className="options-wrapper" ref={optionsRef}>
                {options.map(option => (<div
                    key={option.value}
                    onClick={() => onSelectOption(option)}
                    className={
                        options[0] === option ? "option first" :
                        options[options.length - 1] === option ? "option last" :
                        "option"
                    }
                >{option.label}
                </div>))}
            </div> : <div ref={optionsRef}/>}
        </div>
    )
}

export default Dropdown;